export default __webpack_public_path__ + "static/media/balmain_2.f9af3bae.jpg";